import { Modal } from "antd";
import { useTranslation } from "react-i18next";
import AddTimesheetForm from "./AddTimesheetForm";
import { useEffect } from "react";

const MyTimesheetUpdateModal = ({
    open = false,
    setIsModalOpen = () => { },
    selectedCell = null,
    timesheetOptions = [],
    roleOptions = [],
    taskOptions = [],
    myTimesheetById = [],
    setSelectedTimeSheetId = () => { },
    setSelectedRoleId = () => { },
    onUpdateTimesheet = () => { }
}) => {
    const { t } = useTranslation();

    const clickedDate = selectedCell?.date;
    const record = selectedCell?.record || {};
    const isCreateMode = !myTimesheetById?.txnMyTimeSheetId;

    // const fallbackInitialValues = {
    //     recordingDate: clickedDate,
    //     projectId: record?.projectId || undefined,
    //     roleId: record?.roleId || undefined,
    //     taskId: record?.subtaskId || record?.taskId || undefined,
    // };

    const fallbackInitialValues = {
        recordingDate: clickedDate,
        projectId: record?.projectId,
        roleId: record?.roleId || record?.stpTimeSheetRoleId,
        taskId: record?.subtaskId || record?.taskId,
        description: "",
        billableFlag: record?.billable || false,
        reworkFlag: record?.reworkFlag || false,
        totalWorkingHours: 0,
        totalWorkingMinutes: 0,
    };

    // const initialValues = isCreateMode
    //     ? fallbackInitialValues
    //     : {
    //         ...myTimesheetById,
    //         ...record,
    //         projectId: record?.projectId || undefined,
    //         description: myTimesheetById?.description || "",
    //         billableFlag: myTimesheetById?.billableFlag ?? false,
    //         reworkFlag: myTimesheetById?.reworkFlag ?? false,
    //         totalWorkingHours: myTimesheetById?.totalWorkingHours ?? 0,
    //         totalWorkingMinutes: myTimesheetById?.totalWorkingMinutes ?? 0,
    //     };

    const initialValues = isCreateMode
        ? fallbackInitialValues
        : {
            txnMyTimeSheetId: myTimesheetById?.txnMyTimeSheetId,
            recordingDate: myTimesheetById?.recordingDate || clickedDate,
            description: myTimesheetById?.description || "",
            billableFlag: myTimesheetById?.billableFlag ?? false,
            reworkFlag: myTimesheetById?.reworkFlag ?? false,
            totalWorkingHours: myTimesheetById?.totalWorkingHours ?? 0,
            totalWorkingMinutes: myTimesheetById?.totalWorkingMinutes ?? 0,
            projectId: record?.projectId || myTimesheetById?.projectId,
            roleId: record?.roleId || myTimesheetById?.roleId || record?.stpTimeSheetRoleId,
            taskId: record?.subtaskId || record?.taskId || myTimesheetById?.taskId,
        };

    useEffect(() => {
        if (initialValues?.projectId) {
            setSelectedTimeSheetId(initialValues.projectId);
            setSelectedRoleId(initialValues.roleId);
        }
    }, [initialValues?.projectId, setSelectedTimeSheetId, setSelectedRoleId]);

    return (
        <Modal
            open={open}
            title={
                <span style={{ color: "#667085" }}>
                    {t("my_timesheet.label.update_timesheet")}
                </span>
            }
            footer={null}
            closable={false}
            maskClosable={false}
            width={"75vw"}
        >
            <AddTimesheetForm
                initialValues={initialValues}
                editRecord={!isCreateMode}
                onCancel={() => setIsModalOpen(false)}
                taskOptions={taskOptions}
                roleOptions={roleOptions}
                timesheetOptions={timesheetOptions}
                onProjectChange={(value) => setSelectedTimeSheetId(value)}
                onRoleChange={(value) => setSelectedRoleId(value)}
                onUpdateTimesheet={onUpdateTimesheet}
                setIsModalOpen={setIsModalOpen}
                calendarUpdate={true}
            />
        </Modal>
    )
}

export default MyTimesheetUpdateModal;